import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {TreatmentJourneyStepFeedbackModel} from "./treatmentJourneyStepFeedback.model";
import {Injectable} from "@angular/core";
import {TreatmentJourneyStepTriggerModel} from "./treatmentJourneyStepTrigger.model";
import {
    LovValueSummaryConverter
} from "../../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {PermissionsConverter} from "../../../../../../../common/converter/permissions.converter";
import {DateConverter} from "../../../../../../../common/converter/date.converter";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyStepTriggerConverter extends HttpModelConverter<TreatmentJourneyStepTriggerModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private permissionsConverter: PermissionsConverter,
                private dateConverter: DateConverter) {
        super();
    }

    protected createInstance(): TreatmentJourneyStepTriggerModel {
        return new TreatmentJourneyStepTriggerModel();
    }

    protected enrichObject(result: TreatmentJourneyStepTriggerModel, src: TreatmentJourneyStepTriggerModel) {
        result.type = this.lovValueSummaryConverter.convert(src.type);
        result.permissions = this.permissionsConverter.convert(src.permissions);
        result.date = this.dateConverter.convert(src.date);
        result.estimatedDate = this.dateConverter.convert(src.estimatedDate);
    }

}